import { gql } from 'graphql-request';

export const HOLDING_FRAGMENT = gql`
  fragment holdingFields on Holding {
    companyId
    isAnalysisRestricted
  }
`;

export const PORTFOLIOS_FRAGMENT = gql`
  fragment portfolioFields on Portfolio {
    id
    name
    createdAt
    currencyISO
    updatedAt
    type
    manualInputOption
    isAnalysisRestricted
    link {
      brokerageName
    }
    holdings {
      ...holdingFields
    }
  }
  ${HOLDING_FRAGMENT}
`;
